import {
  computed,
  defineComponent,
  onMounted,
  reactive,
} from '@vue/composition-api';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-get-file/dist/filepond-plugin-get-file.min.css';
import { useInputFile } from '@/shared/hooks/useInputFile';
import { useResultDocument } from '@/shared/hooks/useResultDocument';
import { useTitle } from '@/shared/hooks/useTitle';
import { useStore } from '@/store';
import {
  Dialog,
  FileUploader,
  List,
  ListItem,
  Typography,
} from '@/components/parts';
import { handleError } from '@/utils/handleError';

type ReactiveData = {
  listItems: ListItem[];
  startAt: string;
  endAt: string;
  completeMessage: string;
};

export default defineComponent({
  components: {
    RehearsalList: List,
    Typography,
    FileUploader,
    Dialog,
  },
  setup() {
    const store = useStore();
    const { setTitle } = useTitle();

    const { files, handleChangeFile } = useInputFile();
    const {
      getResultPublicationDocument,
      saveResultDocument,
      downloadResultPublicationDocument,
    } = useResultDocument('REHEARSAL');

    const state = reactive<ReactiveData>({
      listItems: [],
      startAt: '',
      endAt: '',
      completeMessage: '',
    });

    const initialize = async () => {
      const resultDocument = await getResultPublicationDocument();

      const listItems: ListItem[] = [
        {
          label: 'URL',
          content: resultDocument.url,
          link: resultDocument.url,
        },
        {
          label: '更新者',
          content: resultDocument.updatedBy,
        },
        {
          label: '更新日時',
          content: resultDocument.updatedAt,
        },
        {
          label: '掲載PDFファイル',
          content: resultDocument.name,
          annotation: '(印刷：可能)',
          isDownload: true,
          download: downloadResultPublicationDocument,
        },
      ];

      state.listItems = listItems;
      state.startAt = resultDocument.startAt;
      state.endAt = resultDocument.endAt;
    };

    onMounted(() => {
      setTitle({ title: 'リハーサル準備', icon: 'mdi-square-edit-outline' });

      initialize();
    });

    const handleSubmit = async () => {
      const [fileData] = files.value;
      if (!fileData) return;

      const formData = new FormData();
      formData.append('official_document', fileData.file);
      formData.append('publish_type', '2');

      return saveResultDocument(formData)
        .then(() => {
          initialize();
          state.completeMessage =
            '登録情報の掲載PDFファイルのリンクをクリックし、掲載内容に問題ないことを確認してください。';
        })
        .catch((error) => {
          const errorMessage = handleError(error);

          state.completeMessage = errorMessage;
        });
    };

    return {
      state,
      files,
      handleChangeFile,
      handleSubmit,
      accept: store.getters.validation.passing_file_mimetype,
      message: computed(() => state.completeMessage),
    };
  },
});
